/* @flow */

const orderRoutes: Array<*> = [];

export default orderRoutes;
